export default "__VITE_ASSET__issuxTQZ__"